import { LoginUser } from './loginUser';
import { Dependent } from './dependent';

export class Subscriber extends LoginUser {
  dependents: Array<Dependent>;

  constructor(
    isOverTobaccoAgeLimit: any,
    tobaccoIndicator = '',
    tobaccoUseEffectiveBeginDate = '',
    tobaccoUseEffectiveEndDate = '',
    tobaccoUseLastReportDate = '',
    tobaccoFreeStatus = '',
    hasPrepopulationError = false,
    hasRequiredError = false,
    firstName = '',
    lastName = '',
    dateOfBirth = '',
    coveredIndividualId = '',
    isOffExchange = false,
    isOnExchange = false,
    dependents: Array<Dependent> = [],
  ) {
    super(
      isOverTobaccoAgeLimit,
      tobaccoIndicator,
      tobaccoUseEffectiveBeginDate,
      tobaccoUseEffectiveEndDate,
      tobaccoUseLastReportDate,
      tobaccoFreeStatus,
      hasPrepopulationError,
      hasRequiredError,
      firstName,
      lastName,
      dateOfBirth,
      coveredIndividualId,
      isOffExchange,
      isOnExchange,
    );

    this.dependents = dependents;
  }
}
